<template>
  <section class="section">
    <div class="journal-container">
      <template v-if="article">
        <h2 class="header t-h2">Rosenberg Journal</h2>
        <Transition name="journal">
          <JournalItem
            :key="article.id"
            class="journal-section"
            :title="article.title"
            :lead="article.lead"
          />
        </Transition>
      </template>
    </div>
  </section>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import JournalItem from '@/components/JournalItem.vue'
import { useJournalStore } from '@/stores/useJournalStore'

const store = useJournalStore()

const article = computed(() => store.article)
</script>
<style lang="scss" scoped>
.header {
  margin-bottom: vh(20px);
  color: #05b742;
}

.journal-container {
  position: relative;
  width: 100%;
  height: vh(430px);
  margin-top: vh(120px);
  margin-bottom: vh(33px);
  margin-left: vw(235px);
}

.journal-section {
  position: absolute;
}

.journal-enter-active {
  transition: 1.5s ease-out 0.5s;
  transition-property: opacity, transform;
}

.journal-leave-active {
  transition: 0.5s ease-out;
  transition-property: opacity, transform;
}

.journal-enter-from {
  opacity: 0;
  transform: translateY(vh(50px));
}

.journal-leave-to {
  opacity: 0;
  transform: translateY(vh(-20px));
}
</style>
